// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltipV2_tooltip__Kz-OG","positionRelative":"tooltipV2_positionRelative__LiVyz","tooltipContent":"tooltipV2_tooltipContent__kfIC-","triangle":"tooltipV2_triangle__SJUgw"};